// extracted by mini-css-extract-plugin
export default {"completedDocuments":"styles_completedDocuments__UHhSc"};